<template>
    <div class="fullHeight mx-0">
        <span>Logging in via Springer...</span>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import SpringerCasService from '@/services/SpringerCasService';

    export default {
        name: 'SpringerAuth',
        async created() {
            if (this.registrationType === 'springer') {
                if (this.$route.query.pwa) {
                    window.localStorage.setItem('pwa', this.$route.params.event_id);
                }
                let springer = new SpringerCasService(this.$route.params.event_id, this.springerOAuthClientId);
                springer.redirectToAuthorizeAndSaveState();
            }
        },
        computed: {
            ...mapGetters('project', ['currentEvent', 'registrationType', 'springerOAuthClientId']),
        },
    };
</script>

